import { useConfigPermission } from "context/useConfigPermission";
import { useProductConfiguration } from "context/useProductConfiguration";
import { isBulletPointsConfigEmpty, isExtraLinkConfigEmpty, isInfoTextConfigEmpty, isLogoConfigEmpty, isSearchWordsConfigEmpty } from "utility/ProductUtility";

type AnyConfigEmptyNagProps = {
    id: string
}

const AnyConfigEmptyNag = ({ id }: AnyConfigEmptyNagProps) => {

    const { productConfigurationsByCompany } = useProductConfiguration();
    const { canConfig } = useConfigPermission();

    if (id === undefined || id === null)
        return <></>;


    const config = productConfigurationsByCompany[id];

    if (!canConfig(id) || !config)
        return null;


    if (isSearchWordsConfigEmpty(config.searchWords) || isLogoConfigEmpty(config.logo) || isBulletPointsConfigEmpty(config.bulletPoints) || isInfoTextConfigEmpty(config.infoText) || isExtraLinkConfigEmpty(config.extraLinks)) {


        return (
            <div className="cc-bg-theme-orange mb-4 fw-medium rounded-2">
                <a href="#produkter" className="text-white px-3 py-3 d-block cc-underline-none">
                    <i className="bi bi-exclamation-triangle-fill float-end ms-2"></i>
                    <p className="m-0"><span>Kjøpte produkter mangler <u className="cc-underline-50 d-inline-block">utfylt informasjon</u>!</span></p>
                </a>
            </div>)
    }
    else {
        return null;
    }


}

export default AnyConfigEmptyNag;